import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, ArrowRight, X } from "lucide-react";
import { scrollToId, whatsappLink } from "@/lib/site";

const useFormVisible = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.getElementById("contatti");
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => setVisible(e.isIntersecting), { threshold: 0.05 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return visible;
};

export const Tray = ({ selected, onClear }) => {
  const hide = useFormVisible();
  return (
  <AnimatePresence>
    {selected.length > 0 && !hide && (
      <motion.div
        initial={{ y: 120, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 120, opacity: 0 }}
        transition={{ type: "spring", stiffness: 260, damping: 26 }}
        className="fixed inset-x-3 bottom-3 z-40 mx-auto max-w-2xl"
        data-testid="floating-selection-tray"
      >
        <div className="flex items-center gap-3 rounded-full border border-white/10 bg-[#0D1424]/90 p-2 pl-3 shadow-[0_20px_60px_-20px_rgba(0,229,255,0.4)] backdrop-blur-xl">
          <button onClick={onClear} data-testid="tray-clear" aria-label="Svuota selezione" className="grid h-9 w-9 shrink-0 place-items-center rounded-full text-slate-400 hover:bg-white/10 hover:text-white">
            <X className="h-4 w-4" />
          </button>
          <motion.span key={selected.length} initial={{ scale: 1.4 }} animate={{ scale: 1 }} data-testid="tray-count-badge" className="grid h-9 min-w-9 place-items-center rounded-full bg-[var(--cyan)] px-2 font-mono text-sm font-bold text-black">
            {selected.length}
          </motion.span>
          <span className="hidden flex-1 text-sm text-slate-300 sm:block">servizi nel tuo menu</span>
          <span className="flex-1 sm:hidden" />
          <a data-testid="tray-cta-whatsapp" href={whatsappLink(selected)} target="_blank" rel="noopener noreferrer" aria-label="Invia su WhatsApp" className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-white/15 text-white transition-colors hover:border-[#25D366] hover:text-[#25D366]">
            <MessageCircle className="h-5 w-5" />
          </a>
          <button data-testid="tray-cta-quote" onClick={() => scrollToId("contatti")} className="btn-cyan !py-3">
            Preventivo <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
  );
};
